import { SET_NOTY_NEW_FIELD, SET_NOTY_NEW_MENU, SET_NOTY_COUNT } from './types';

export const setNotyNewField = data => {
  return {
    type: SET_NOTY_NEW_FIELD,
    payload: data,
  };
};

export const setNotyNewMenu = data => {
  return {
    type: SET_NOTY_NEW_MENU,
    payload: data,
  };
};

export const setNotyCount = data => {
  return {
    type: SET_NOTY_COUNT,
    payload: data,
  };
};
